export default function sessions (a, b) {
  var c = window; c.SessionStackKey = a, c[a] = c[a] || {
    t: b,
    q: []
  };
  for (var d = ["start", "stop", "identify", "getSessionId", "log", "setOnDataCallback"], e = 0; e < d.length; e++)!function (b) {
    c[a][b] = c[a][b] || function () {
      c[a].q.push([b].concat([].slice.call(arguments, 0)));
    }
  }(d[e]);
  var f = document.createElement("script");
  f.async = 1, f.src = "https://cdn.sessionstack.com/sessionstack.js";
  var g = document.getElementsByTagName("script")[0];
  if (g && g.parentNode) {
    g.parentNode.insertBefore(f, g);
  } else {
    (document.head || document.body || document.documentElement).appendChild(f);
  }
};
